export default {
  shipmentHelpers: {},
  shipmentStatusFilters: [],
  shipment: {
    id: 0,
    address_from: {
      data: {
        city_code: '',
        district_code: '',
        city: {},
        district: {}
      }
    },
    address_to: {
      data: {
        city_code: '',
        district_code: '',
        city: {},
        district: {}
      }
    },
    picker: {
      data: {}
    },
    receiver: {
      data: {}
    },
    parcel: {
      data: {
        quantity: 1,
        cod_amount: 0,
        length: 0,
        width: 0,
        height: 0,
        weight: 0,
        amount: 0
      }
    },
    metadata: ''
  }
}



// WEBPACK FOOTER //
// ./src/components/shipment/store/state.js